import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {ProductDeliveredModel} from "../../../api/entity/productDelivered.model";
import {DefaultDataservice} from "../../../../../../store/core/dataservice/default.dataservice";
import {CustomizeHttpUrlGenerator} from "../../../../../../store/core/url/customizeHttpUrlGenerator";

@Injectable()
export class ProductDeliveredDataService extends DefaultDataservice<ProductDeliveredModel> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig) {
        super('ProductDelivered', http, httpUrlGenerator, logger, config);
    }
}
